import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { TableHeader } from 'ui/tableHeader';
import { PaginationFooter } from 'ui/paginationFooter';

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: ${pxToRem(610)};
  margin: 0 -${spacing.layoutLRPadding};
`;

export const StyledTableHeader = styled(TableHeader)`
  & > div:first-child {
    padding-left: ${spacing.double};
  }

  && {
    border-top-width: ${spacing.single};
  }
`;

export const StyledPaginationFooter = styled(PaginationFooter)`
  margin: 0 -${spacing.layoutLRPadding};
`;
